// src/components/Footer.js
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { siteData } from "../data/siteData";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setEmail("");
    setTimeout(() => setSubscribed(false), 3000);
  };

  const getSocialIcon = (iconName) => {
    const icons = {
      facebook: (
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.406.595 24 1.325 24h11.495v-9.294H9.691V11.01h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.696h-3.12V24h6.116C23.406 24 24 23.406 24 22.674V1.326C24 .592 23.406 0 22.675 0" />
        </svg>
      ),
      linkedin: (
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm15.5 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.968v5.699h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.838-1.563 3.036 0 3.6 2.001 3.6 4.601v5.595z" />
        </svg>
      ),
      instagram: (
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.242 1.308 3.608.058 1.266.069 1.646.069 4.85s-.011 3.584-.069 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.242 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.011-4.85-.069c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.242-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608.974-.974 2.242-1.246 3.608-1.308C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.771.131 4.659.414 3.678 1.395 2.697 2.376 2.414 3.488 2.355 4.769.013 8.332 0 8.741 0 12c0 3.259.013 3.668.072 4.948.059 1.281.342 2.393 1.323 3.374.981.981 2.093 1.264 3.374 1.323C8.332 23.987 8.741 24 12 24s3.668-.013 4.948-.072c1.281-.059 2.393-.342 3.374-1.323.981-.981 1.264-2.093 1.323-3.374.059-1.28.072-1.689.072-4.948s-.013-3.668-.072-4.948c-.059-1.281-.342-2.393-1.323-3.374-.981-.981-2.093-1.264-3.374-1.323C15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
        </svg>
      ),
      twitter: (
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M24 4.557a9.93 9.93 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724c-.951.564-2.005.974-3.127 1.195a4.916 4.916 0 0 0-8.38 4.482C7.691 8.095 4.066 6.13 1.64 3.161c-.542.929-.856 2.01-.857 3.17 0 2.188 1.115 4.116 2.823 5.247a4.904 4.904 0 0 1-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.936 4.936 0 0 1-2.224.084c.627 1.956 2.444 3.377 4.6 3.417A9.867 9.867 0 0 1 0 21.543a13.94 13.94 0 0 0 7.548 2.209c9.142 0 14.307-7.721 13.995-14.646A9.936 9.936 0 0 0 24 4.557z" />
        </svg>
      ),
    };
    return icons[iconName] || null;
  };

  // Star animation logic
  const starCanvasRef = useRef(null);
  useEffect(() => {
    const canvas = starCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let width = (canvas.width = canvas.offsetWidth);
    let height = (canvas.height = canvas.offsetHeight);
    let animationFrameId;
    const STAR_COUNT = 80;
    const stars = Array.from({ length: STAR_COUNT }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      r: Math.random() * 1.2 + 0.5,
      speed: Math.random() * 0.2 + 0.05,
      opacity: Math.random() * 0.5 + 0.5,
    }));

    function drawStars() {
      ctx.clearRect(0, 0, width, height);
      for (const star of stars) {
        ctx.save();
        ctx.globalAlpha = star.opacity;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, 2 * Math.PI);
        ctx.fillStyle = "#fff";
        ctx.shadowColor = "#b3d1ff";
        ctx.shadowBlur = 8;
        ctx.fill();
        ctx.restore();
        // Move star
        star.y += star.speed;
        if (star.y > height) {
          star.y = 0;
          star.x = Math.random() * width;
        }
      }
      animationFrameId = requestAnimationFrame(drawStars);
    }

    drawStars();
    window.addEventListener("resize", handleResize);
    function handleResize() {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
    }
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <footer className="relative custom-footer-bg text-white overflow-hidden">
      {/* Star Animation Canvas */}
      <canvas
        ref={starCanvasRef}
        className="absolute inset-0 w-full h-full pointer-events-none z-0 animate-fadein"
        style={{ display: "block" }}
      />
      {/* Enhanced Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-500 via-indigo-600 to-blue-900 z-10"></div>
      <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl z-10"></div>
      <div className="absolute bottom-0 left-0 w-40 h-40 bg-indigo-700/20 rounded-full blur-3xl z-10"></div>
      <div className="absolute top-1/3 left-1/4 w-20 h-20 bg-blue-600/10 rounded-full blur-2xl z-10"></div>

      {/* Curved Top Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden z-10 h-12">
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="absolute -top-10 left-0 w-full h-24 text-blue-900/10 rotate-180"
          fill="currentColor"
        >
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"></path>
        </svg>
      </div>
      {/* Main Footer Content - enhanced beautiful grid layout with cards */}
      <div className="relative container mx-auto px-4 pt-14 pb-8 z-20 min-h-[280px]">
        <div className="flex flex-col items-center mb-8">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-3 group">
            <div className="relative">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-105">
                <img
                  src={siteData.logo}
                  alt={siteData.siteName}
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div className="absolute -inset-1 bg-blue-600/20 rounded-3xl blur-xl group-hover:bg-blue-500/30 transition-all duration-500 group-hover:blur-2xl opacity-70"></div>
            </div>
            <span className="text-3xl font-bold text-white drop-shadow-lg text-center">
              {siteData.siteName}
            </span>
          </div>

          <div className="flex space-x-4 mt-5">
            {siteData.footer.socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group w-10 h-10 bg-blue-800/40 border border-blue-700 rounded-xl flex items-center justify-center text-blue-200 hover:text-white hover:bg-blue-700/60 shadow hover:shadow-lg transition-all duration-300"
                title={social.name}
              >
                <div className="relative z-10">
                  {getSocialIcon(social.icon)}
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Content Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch mx-auto max-w-7xl">
          {/* Quick Links - Card 1 */}
          <div className="bg-blue-900/30 backdrop-blur-lg rounded-2xl p-4 border border-blue-700/30 shadow-xl transform transition-all hover:shadow-2xl hover:-translate-y-1 duration-300 flex flex-col h-60 justify-center items-center">
            <h3 className="text-sm font-semibold text-white mb-4 flex items-center tracking-wide">
              <span className="inline-block w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
              Quick Links
            </h3>
            <ul className="space-y-3 flex-grow">
              {siteData.footer.quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-sm text-blue-100 hover:text-white transition-all duration-200 flex items-center gap-2 font-medium"
                  >
                    <span className="h-[2px] w-4 bg-blue-400 mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info - Card 2 */}
          <div className="bg-blue-900/30 backdrop-blur-lg rounded-2xl p-4 border border-blue-700/30 shadow-xl transform transition-all hover:shadow-2xl hover:-translate-y-1 duration-300 flex flex-col h-60 justify-center items-center">
            <h3 className="text-sm font-semibold text-white mb-4 flex items-center tracking-wide">
              <span className="inline-block w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
              Contact
            </h3>
            <div className="text-sm text-blue-100 space-y-3 flex-grow">
              <p className="flex gap-2">
                <span className="font-semibold text-white min-w-[70px]">
                  Address:
                </span>
                <span className="ml-1">{siteData.contact.address}</span>
              </p>
              <p className="flex gap-2">
                <span className="font-semibold text-white min-w-[70px]">
                  Phone:
                </span>
                <a
                  href={`tel:${siteData.contact.phone1}`}
                  className="ml-1 text-blue-300 hover:text-white hover:underline transition-colors font-medium"
                >
                  {siteData.contact.phone1}
                </a>
              </p>
              <p className="flex gap-2">
                <span className="font-semibold text-white min-w-[70px]">
                  Phone:
                </span>
                <a
                  href={`tel:${siteData.contact.phone2}`}
                  className="ml-1 text-blue-300 hover:text-white hover:underline transition-colors font-medium"
                >
                  {siteData.contact.phone2}
                </a>
              </p>
              <p className="flex gap-2">
                <span className="font-semibold text-white min-w-[70px]">
                  Email:
                </span>
                <a
                  href={`mailto:${siteData.contact.email}`}
                  className="ml-1 text-blue-300 hover:text-white hover:underline transition-colors font-medium"
                >
                  {siteData.contact.email}
                </a>
              </p>
            </div>
          </div>

          {/* Newsletter Card */}
          <div className="bg-gradient-to-br from-blue-900/40 to-indigo-900/40 backdrop-blur-lg rounded-2xl p-4 border border-blue-700/30 shadow-xl transform transition-all hover:shadow-2xl hover:-translate-y-1 duration-300 flex flex-col h-60">
            <h3 className="text-sm font-semibold text-white mb-2 flex items-center">
              <span className="inline-block w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
              {siteData.footer.newsletter.title}
            </h3>
            {/* Newsletter Signup */}
            <form
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col gap-2 w-full"
            >
              <div className="flex gap-1">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 px-3 py-2 bg-blue-900/60 border border-blue-700/70 rounded-l-lg text-blue-100 placeholder-blue-300/70 focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 text-xs"
                  required
                />
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-500 text-white px-3 py-2 rounded-r-lg transition-all duration-200 text-xs font-medium border border-blue-500 hover:border-blue-400 shadow-lg hover:shadow-blue-500/30"
                >
                  Subscribe
                </button>
              </div>
              {subscribed && (
                <p className="text-blue-300 text-xs mt-1 animate-pulse">
                  Thank you for subscribing!
                </p>
              )}
            </form>

            <div className="mt-4 w-full flex-grow flex items-center">
              <p className="text-blue-100 text-xs">
                Subscribe to our newsletter to stay updated with the latest news
                and events from UMMES and the Department of Mechanical
                Engineering.
              </p>
            </div>
          </div>

          {/* Location Map - Card 4 */}
          <div className="bg-blue-900/30 backdrop-blur-lg rounded-2xl p-4 border border-blue-700/30 shadow-xl transform transition-all hover:shadow-2xl hover:-translate-y-1 duration-300 flex flex-col h-60">
            <h3 className="text-sm font-semibold text-white mb-2 flex items-center">
              <span className="inline-block w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
              Location
            </h3>
            <p className="text-blue-100 text-xs mb-2">
              {siteData.contact.address}
            </p>
            {/* Embedded Map with enhanced styling */}
            <div className="w-full flex-grow rounded-xl overflow-hidden shadow-lg border border-blue-700/50">
              <iframe
                title="UOM Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.7921349441076!2d79.89829207480841!3d6.79512759320214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae245416b7f34b5%3A0x7bd32721ab02560e!2sUniversity%20of%20Moratuwa!5e0!3m2!1sen!2slk!4v1757323341733!5m2!1sen!2slk"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
            </div>
            {/* Google Maps Link */}
            <a
              href="https://goo.gl/maps/7U1QFUw2sPRQmEzQ6"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 text-xs flex items-center mt-2 hover:text-white transition-colors group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
              <span className="group-hover:underline">View on Google Maps</span>
            </a>
          </div>
        </div>
      </div>
      {/* Footer bottom section - simplified */}
      <div className="relative">
        <div className="absolute top-0 left-0 w-full overflow-hidden z-10 h-8">
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="absolute top-0 left-0 w-full h-8 text-blue-900/20"
            fill="currentColor"
          >
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
          </svg>
        </div>

        <div className="pt-8 pb-4 px-4 flex items-center justify-center bg-gradient-to-r from-blue-900/90 via-indigo-900/90 to-blue-900/90 shadow-inner relative z-20">
          <p className="font-medium text-white text-center">
            &copy; {new Date().getFullYear()}{" "}
            <span className="text-blue-300">
              <Link
                href="/"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                UMMES
              </Link>
            </span>{" "}
            All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
